import { useEffect, RefObject } from 'react'

type AnyEvent = MouseEvent | TouchEvent

export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    handler: (event: AnyEvent) => void,
    ignoredRefs: Array<RefObject<HTMLElement | null>> = []
) => {
    useEffect(() => {
        const listener = (event: AnyEvent) => {
            const el = ref?.current
            const target = event.target as Node

            if (!el || el.contains(target)) {
                return
            }

            if (ignoredRefs.some((ignoredRef) => ignoredRef.current?.contains(target))) {
                return
            }

            handler(event)
        }

        document.addEventListener(`mousedown`, listener)
        document.addEventListener(`touchstart`, listener)

        return () => {
            document.removeEventListener(`mousedown`, listener)
            document.removeEventListener(`touchstart`, listener)
        }
    }, [ref, handler, ignoredRefs])
}
